const ITEMS = [
    "MOVIMENTO",
    "EVOLUÇÃO",
    "SOLUÇÕES",
    "DIAGNÓSTICO SOB MEDIDA",
    "MELHORIA CONTÍNUA",
    "AUTORIDADE DIGITAL",
    "CRESCIMENTO ESTRATÉGICO",
];

const Marquee = () => (
    <div className="overflow-hidden border-y border-white/10 bg-navy-ink py-5" data-testid="editorial-marquee" aria-hidden="true">
        <div className="marquee-track">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="px-8 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
                        {item}
                    </span>
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                </span>
            ))}
        </div>
    </div>
);

export default Marquee;
